import React, { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS } from "../../lib/constants";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Before & After", href: "#gallery" },
  { label: "Service Area", href: "#service-area" },
  { label: "Contact", href: "#quote" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-white border-b-2 border-navy transition-shadow ${
        scrolled ? "shadow-[0_6px_0_0_#0a192f]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-4">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-3 shrink-0"
        >
          <img
            src={BUSINESS.logo}
            alt="B&C Junk Removal Pros"
            className="h-14 w-14 object-contain"
          />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-display text-lg text-navy">B&amp;C JUNK REMOVAL</span>
            <span className="font-body text-[10px] tracking-[0.3em] text-navy/70 uppercase">
              Syracuse · NY
            </span>
          </div>
        </a>

        <nav
          data-testid="header-nav"
          className="hidden lg:flex items-center gap-10"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="font-body font-bold text-sm uppercase tracking-[0.18em] text-navy hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={BUSINESS.phoneHref}
            data-testid="header-call-btn"
            className="brutal-btn hidden sm:inline-flex items-center gap-2 bg-gold text-navy px-5 py-3 font-display text-sm uppercase tracking-wider border-2 border-navy"
          >
            <Phone className="h-4 w-4" strokeWidth={3} />
            {BUSINESS.phoneDisplay}
          </a>

          <a
            href={BUSINESS.phoneHref}
            data-testid="header-call-btn-mobile"
            className="sm:hidden inline-flex items-center justify-center h-11 w-11 bg-gold border-2 border-navy text-navy"
            aria-label="Call now"
          >
            <Phone className="h-5 w-5" strokeWidth={3} />
          </a>

          <button
            data-testid="header-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center h-11 w-11 border-2 border-navy text-navy"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t-2 border-navy bg-white"
        >
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-display text-lg uppercase tracking-wide text-navy py-3 border-b border-navy/20"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
